module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdtregister paddingTop45"
  }, [_c('x-header', {
    staticClass: "zdyheaderBlue",
    attrs: {
      "left-options": {
        showBack: false
      }
    }
  }, [_vm._v("MDT登记")]), _vm._v(" "), _c('div', {
    staticClass: "describe"
  }, [_vm._v("\n       为切实让患者感受难病共医的多学科诊疗服务，武汉锦欣中西医结合妇产医院多学科联合门诊集合了：生殖不孕科、妇科、泌尿外科、胚胎实验室、超声科、药剂科、放射科、心理卫生和护理团队专家们在同一时间地点共同讨论患者临床资料，为患者做出最合适的个体化方案。\n     ")]), _vm._v(" "), _c('group', [_c('cell', {
    attrs: {
      "title": "姓名:",
      "value": _vm.getdata.patientName
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "卡号:",
      "value": _vm.getdata.identityNo
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "出生日期:",
      "value": _vm.getdata.birthday
    }
  }), _vm._v(" "), _c('cell', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "title": "入组条件",
      "value-align": "left"
    }
  }, [_c('checker', {
    attrs: {
      "type": "checkbox",
      "default-item-class": "demo1-item",
      "selected-item-class": "demo1-item-selected"
    },
    on: {
      "on-change": function($event) {
        _vm.radioChoose('pointerCancel')
      }
    },
    model: {
      value: (_vm.pointerCancel),
      callback: function($$v) {
        _vm.pointerCancel = $$v
      },
      expression: "pointerCancel"
    }
  }, _vm._l((_vm.pointerCanceloptions), function(item, index) {
    return _c('checker-item', {
      key: index,
      attrs: {
        "value": item
      }
    }, [_vm._v(_vm._s(item.sZdCmc))])
  })), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pointerCancelIcon),
      expression: "pointerCancelIcon"
    }],
    staticClass: "warnIcon",
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        _vm.IconClick('必选哦！')
      }
    }
  })], 1), _vm._v(" "), _c('x-textarea', {
    attrs: {
      "title": "情况描述:",
      "placeholder": "请输入情况描述",
      "show-counter": false,
      "rows": 1,
      "autosize": ""
    },
    model: {
      value: (_vm.formdata.situDesc),
      callback: function($$v) {
        _vm.$set(_vm.formdata, "situDesc", $$v)
      },
      expression: "formdata.situDesc"
    }
  }), _vm._v(" "), _c('x-textarea', {
    attrs: {
      "title": "需求:",
      "placeholder": "请输入需求",
      "show-counter": false,
      "rows": 1,
      "autosize": ""
    },
    model: {
      value: (_vm.formdata.need),
      callback: function($$v) {
        _vm.$set(_vm.formdata, "need", $$v)
      },
      expression: "formdata.need"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "red",
      "margin": "10px 15px",
      "text-align": "justify",
      "position": "relative"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block",
      "vertical-align": "top",
      "position": "absolute",
      "left": "0px",
      "top": "0px"
    }
  }, [_vm._v("\n         说明：\n       ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-left": "45px"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.dection[0]))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_vm._v(_vm._s(_vm.dection[1]))])])]), _vm._v(" "), _c('x-button', {
    staticClass: "orangeBtn",
    attrs: {
      "disabled": _vm.submitDisable
    },
    nativeOn: {
      "click": function($event) {
        _vm.sureClick($event)
      }
    }
  }, [_vm._v("提 交")]), _vm._v(" "), _c('toast', {
    attrs: {
      "type": "text",
      "time": 800,
      "is-show-mask": "",
      "text": _vm.toastTxt,
      "position": "middle"
    },
    model: {
      value: (_vm.toastShow),
      callback: function($$v) {
        _vm.toastShow = $$v
      },
      expression: "toastShow"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('confirm', {
    attrs: {
      "title": "提示"
    },
    on: {
      "on-confirm": _vm.onConfirm
    },
    model: {
      value: (_vm.confirmshow),
      callback: function($$v) {
        _vm.confirmshow = $$v
      },
      expression: "confirmshow"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block",
      "text-align": "left",
      "color": "red",
      "font-size": "17px"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.dection[0]))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_vm._v(_vm._s(_vm.dection[1]))])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b1b57fe","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/project/mdt/mdtregister.vue
// module id = 2JNq
// module chunks = 5